import PropTypes from 'prop-types';
import React from 'react';
import {saveAccount, cancelAccountEdit} from '../actions/AccountActionCreators';
import {connectToStores} from 'fluxible-addons-react';
import Actions from '../../../constants/Actions';
import {FormattedMessage, intlShape} from 'react-intl';
import CommonMessages from '../../../intl/CommonMessages';
import AccountMessages from '../components/AccountMessages';
import {Link} from 'react-router';
import {forgotPassword} from '../../../actions/AuthenticationActionCreators';
import Form from 'react-form-controlled';

@connectToStores(['ManageAccountStore', 'PortalUserStore'], (context) => {
  const ManageAccountStore = context.getStore('ManageAccountStore');
  const PortalUserStore = context.getStore('PortalUserStore');

  const user = {
    emailAddress: PortalUserStore.getEmailAddress(),
    firstName: PortalUserStore.getFirstName(),
    lastName: PortalUserStore.getLastName(),
    title: PortalUserStore.getTitle()
  };

  return {
    user,
    passwordResetSent: ManageAccountStore.passwordResetSent()
  };
})
class EditAccount extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    passwordResetSent: PropTypes.bool.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  static async loadAction(context) {
    context.dispatch(Actions.USER_ACCOUNT__EDIT_STARTED);
  }

  buildAlert(message) {
    return <div className='alert alert-success' role='alert'>
      <FormattedMessage {...message} />
    </div>;
  }

  constructor(props) {
    super(props);
    const user = props.user || {};
    this.state = {
      ...user
    };
  }

  saveClicked = () => {
    const {user: {emailAddress}} = this.props;
    const updatedState = {
      ...this.state,
      emailAddress: (emailAddress || '').toLowerCase()
    };
    this.context.executeAction(saveAccount, updatedState);
  };

  cancelClicked = () => {
    this.context.executeAction(cancelAccountEdit);
  };

  resetPasswordClicked = event => {
    const {user: {emailAddress}} = this.props;
    this.context.executeAction(forgotPassword, {
      emailAddress
    });
    event.preventDefault();
  };

  formChanged = state => {
    this.setState(state);
  };

  render() {
    const {passwordResetSent} = this.props;

    const flashMessages = [];

    if (passwordResetSent) {
      flashMessages.push(this.buildAlert(AccountMessages.forgotComplete));
    }

    return (
      <section className='card'>
        <div className='card-body'>
          { flashMessages }
          <Form value={this.state}
                onChange={this.formChanged}
                onSubmit={this.saveClicked}>
            <div className='form-group row'>
              <label htmlFor='emailAddress' className='col-sm-3 col-form-label'>Email Address</label>
              <div className='col-sm-9'>
                <input type='text'
                       className='form-control'
                       name='emailAddress'
                       id='emailAddress'
                       placeholder='Email Address'/>
              </div>
            </div>
            <div className='form-group row'>
              <label htmlFor='firstName' className='col-sm-3 col-form-label'>First Name</label>
              <div className='col-sm-9'>
                <input type='text'
                       className='form-control'
                       name='firstName'
                       id='firstName'
                       placeholder='First Name'/>
              </div>
            </div>
            <div className='form-group row'>
              <label htmlFor='lastName' className='col-sm-3 col-form-label'>Last Name</label>
              <div className='col-sm-9'>
                <input type='text'
                       className='form-control'
                       name='lastName'
                       id='lastName'
                       placeholder='Last Name'/>
              </div>
            </div>
            <div className='form-group row'>
              <label htmlFor='title' className='col-sm-3 col-form-label'>Title</label>
              <div className='col-sm-9'>
                <input type='text'
                       className='form-control'
                       name='title'
                       id='title'
                       placeholder='Title'/>
              </div>
            </div>
            <div className='form-group row'>
              <div className='buttons'>
                <button type='button' className='btn btn-link' onClick={ this.resetPasswordClicked }>Reset Password</button>
                <Link to='/account/view' className='btn btn-link' onClick={ this.cancelClicked }>
                  <FormattedMessage {...CommonMessages.cancel} />
                </Link>
                <button type='submit' className='btn btn-primary'>
                  <FormattedMessage {...CommonMessages.save} />
                </button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

export default EditAccount;



// WEBPACK FOOTER //
// ./src/apps/Account/components/EditAccount.js